import { render } from "./AdminKPI.vue?vue&type=template&id=d641b6bc&ts=true"
import script from "./AdminKPI.vue?vue&type=script&lang=ts"
export * from "./AdminKPI.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__